<template>
  <vs-card>
    <div id="data-list-list-view" class="data-list-container">
      <div class="lg:hidden">
        <vs-button v-if="showCTA" @click="createPatientDetailsDrawer=true" color="primary" >Create Patient</vs-button>
        <div class="mb-2 pt-2 pr-2 flex flex-no-wrap">
          <div class="w-full pr-1">
            <vs-input
              icon="search"
              style="width: 100%"
              placeholder="Search patients..."
              v-model="searchInputString"
              aria-label="Search patients"
            />
          </div>
          <div class="w-24 pl-1">
            <vs-select
              style="width: 100%"
              placeholder="10"
              autocomplete
              vs-multiple
              v-model="dataTableParams.limit"
              class="mr-6"
              aria-label="Select page size"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in limitOptions"
                :clearable="false"
              />
            </vs-select>
          </div>
          <div v-if="!shouldHideClinicSelector" class="w-24 pl-1">
            <vs-select
              v-model="dataTableParams.clinicId"
              placeholder="All Clinics"
              autocomplete
              class="mr-6"
              aria-label="Select clinic"
            >
              <vs-select-item
                :key="index"
                :value="item.clinicId"
                :text="item.name"
                v-for="(item, index) in clinics"
              />
            </vs-select>
          </div>
        </div>
        <div v-if="shouldUseLazyLoading && !searchInputString && patients.length === 0" class="empty-state text-center py-8">
          <p class="text-gray-500">{{ noDataText }}</p>
        </div>
        <ul v-else-if="!shouldUseLazyLoading || searchInputString">
          <li :key="indextr" v-for="(tr, indextr) in patients">
            <div class="rounded mb-2 p-3" style="border: 1px solid #e8e8e8">
              <div class="flex pb-2">
                <h4 class="mr-2 mobile-text">
                  {{
                    patients[indextr].firstName
                      ? patients[indextr].firstName
                      : "N/A" | capitalize
                  }}
                </h4>
                <h4 class="mobile-text pb-2">
                  {{
                    patients[indextr].lastName
                      ? patients[indextr].lastName
                      : "N/A" | capitalize
                  }}
                </h4>
              </div>
              <div>
                <p class="mobile-text pb-2">
                  Gender: {{ patients[indextr].gender || "N/A" }}
                </p>
              </div>
              <div>
                <p class="mobile-text pb-2">
                  DOB: {{ patients[indextr].dateOfBirth || "N/A" }}
                </p>
              </div>
              <div>
                <p class="mobile-text pb-2">
                  Contact Number: {{ patients[indextr].contactNumber || "N/A" }}
                </p>
              </div>
              <div>
                <p class="mobile-text pb-2">
                  Address: {{ patients[indextr].address || "N/A" }}
                </p>
              </div>
              <div class="flex">
                <vs-button
                  type="border"
                  size="small"
                  @click="viewPatientDetail(patients[indextr]._id)"
                  icon-pack="feather"
                  class="mr-2"
                  >View</vs-button
                >
              </div>
            </div>
          </li>
        </ul>
      </div>
      <vs-table
        class="hidden lg:inline"
        ref="table"
        :sst="true"
        :data="tableData"
        @search="search"
        :max-items="dataTableParams.limit"
        :noDataText="noDataText"
        search
        >
        <div
          slot="header"
          class="flex flex-no-wrap flex-grow items-center justify-between mr-2"
        >
          <div class="flex">
            <div>
            <vs-select
              placeholder="10"
              vs-multiple
              autocomplete
              v-model="dataTableParams.limit"
              class="mr-6"
              aria-label="Select page size"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in limitOptions"
                :clearable="false"
              />
            </vs-select>
          </div>
          <div v-if="!shouldHideClinicSelector">
            <vs-select
              v-model="dataTableParams.clinicId"
              autocomplete
              class="mr-6"
              aria-label="Select clinic"
            >
              <vs-select-item
                :key="index"
                :value="item.clinicId"
                :text="item.name"
                v-for="(item, index) in clinics"
              />
            </vs-select>
          </div>
          </div>
          <div class="justify-self-end">
            <vs-button v-if="showCTA" @click="createPatientDetailsDrawer=true" color="primary" >Create Patient</vs-button>
          </div>
        </div>

        <template slot="thead">
          <vs-th sort-key="firstName">Full Name</vs-th>
          <vs-th sort-key="email">Email</vs-th>
          <vs-th sort-key="gender">Gender</vs-th>
          <vs-th sort-key="dateOfBirth">DOB</vs-th>
          <vs-th sort-key="address">Address</vs-th>
          <vs-th sort-key="contactNumber">Contact Number</vs-th>
          <vs-th sort-key="createdAt">Created At</vs-th>
          <vs-th size="25%">Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].firstName">
              {{ data[indextr].fullname || `${data[indextr].firstName} ${data[indextr].lastName}` }}
            </vs-td>
            <vs-td :data="data[indextr].email">
              {{ data[indextr].email }}
            </vs-td>
            <vs-td :data="data[indextr].gender">{{
              data[indextr].gender | capitalize
            }}</vs-td>
            <vs-td :data="data[indextr].dateOfBirth">
              {{ data[indextr].dateOfBirth | date_formatter }}
            </vs-td>
            <vs-td :data="data[indextr].address">
              {{ data[indextr].address }}
            </vs-td>
            <vs-td :data="data[indextr].contactNumber">
              {{ data[indextr].contactNumber }}
            </vs-td>
            <vs-td :data="data[indextr].createdAt">{{
              data[indextr].createdAt | date_formatter
            }}</vs-td>
            <vs-td :data="data[indextr]._id">
              <vs-button
                type="border"
                size="small"
                @click="viewPatientDetail(data[indextr]._id)"
                icon-pack="feather"
                class="mr-2"
                >View</vs-button
              >
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div
        class="m-2 flex sm:justify-between justify-center items-center flex-wrap"
        style="height: 35px; padding-bottom: 30px"
      >
        <span class="mr-2" v-if="totalDocs > 0">
          {{
            dataTableParams.page * dataTableParams.limit -
            (dataTableParams.limit - 1)
          }}
          -
          {{
            totalDocs - dataTableParams.page * dataTableParams.limit > 0
              ? dataTableParams.page * dataTableParams.limit
              : totalDocs
          }}
          of {{ totalDocs }}
        </span>
        <div class="pagination-div" v-if="serverResponded && totalDocs > 0 && totalPage > 1">
          <paginate
            :page-count="totalPage"
            :click-handler="handleChangePage"
            v-model="dataTableParams.page"
            class="pagination"
            :page-range="9"
            :prevText="'<'"
            :nextText="'>'"
          ></paginate>
        </div>
      </div>
    </div>
    <SideDrawerCreatePatient
      :selectedClinic="dataTableParams.clinicId"
      :createPatientDetailsDrawer="createPatientDetailsDrawer"
      @closeSideDrawer="closeSideDrawer"
      @refetchPatientDetail="refetchPatientDetail"
    />
  </vs-card>
</template>

<script>
import { debounce } from 'lodash';
import { mapActions } from 'vuex';
import SideDrawerCreatePatient from '@/views/general-component/treatment-history/SideDrawerCreatePatient.vue';

const SEARCH_DEBOUNCE_DELAY = 500;

export default {
  name: 'PatientList',
  components: {
    SideDrawerCreatePatient,
  },
  props: {
    patients: {
      type: Array,
      default: () => [],
    },
    totalDocs: {
      type: Number,
      default: 0,
    },
    page: {
      type: Number,
      default: 1,
    },
    show: {
      type: Boolean,
      default: false,
    },
    shouldHideClinicSelector: {
      type: Boolean,
      default: false,
    },
    shouldUseLazyLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchInputString: '',
      clinics: [],
      createPatientDetailsDrawer: false,
      dataTableParams: {
        fullName: '',
        page: 1,
        limit: 25,
        clinicId: null,
      },
      limitOptions: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 },
        { text: '50', value: 50 },
        { text: '100', value: 100 },
      ],
      serverResponded: false,
    };
  },
  computed: {
    showCTA() {
      try {
        const user = JSON.parse(localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}User`));
        return user && user.doctorEMRClinics && user.doctorEMRClinics.length > 0;
      } catch (error) {
        return false;
      }
    },
    tableData() {
      return this.shouldUseLazyLoading && !this.searchInputString ? [] : this.patients;
    },
    showPatientList() {
      return !this.shouldUseLazyLoading || this.searchInputString;
    },
    noDataText() {
      return this.shouldUseLazyLoading && !this.searchInputString 
        ? 'To begin search start entering a patient name' 
        : 'No data available';
    },
    totalPage() {
      if (this.totalDocs === 0) return 0;
      
      const { totalDocs, dataTableParams } = this;
      const { limit } = dataTableParams;
      
      return Math.ceil(totalDocs / limit);
    },
  },
  methods:{
    ...mapActions('organization', [
      'fetchOrganizationClinics',
      'fetchOrganizationAllClinics',
    ]),
    refetchPatientDetail() {
      this.dataTableParams.search = null;
      this.$emit('fetchList', this.dataTableParams);
    },
    closeSideDrawer() {
      this.createPatientDetailsDrawer = false;
    },
    async fetchList() {
      await this.$emit('fetchList', this.dataTableParams);
      this.serverResponded = true;
    },
    viewPatientDetail(id) {
      this.$emit('viewPatientDetail', id);
    },
    search(searching) {
      this.searchInputString = searching;
    },
    async getOrganizationAllClinicsList(organizationId) {
      try {
        const res = await this.fetchOrganizationAllClinics(organizationId);
        this.clinics = [...res.data.data];
        this.noDataText = 'No Clinics Available';
      } catch (error) {
        this.clinics = [];
        this.noDataText = 'Error loading clinics';
      }
    },
    async callSearch(search) {
      await this.handleSearch(search,this);
      this.serverResponded = true;
    },
    handleSearchOrFetch(newVal, oldVal) {
      if (this.searchInputString && this.searchInputString.trim().length > 0 && newVal !== oldVal) {
        this.callSearch(this.searchInputString);
      } else if (!this.shouldUseLazyLoading && this.searchInputString.length === 0 && newVal !== oldVal) {
        this.fetchList();
      }
    },
    handleChangePage(page) {
      this.dataTableParams.page = page;
      if (this.searchInputString && this.searchInputString.trim().length > 0) {
        this.callSearch(this.searchInputString);
      } else {
        this.fetchList();
      }
    },
    handleSearch: debounce(async (search,self) => {
      await self.$emit(
        'searchPatients',
        {
          ...self.dataTableParams,
          search: search,
        }
      );
    }, SEARCH_DEBOUNCE_DELAY),
  },
  watch: {
    'searchInputString': function (newVal, oldVal) {
      if (newVal && newVal.trim().length > 0 && newVal !== oldVal) {
        this.dataTableParams.page = 1;
        this.callSearch(newVal);
      }
      else if (newVal.length === 0 && oldVal.length !== 0) {
        this.dataTableParams.page = 1;
        if (this.shouldUseLazyLoading) {
          this.$emit('clearResults');
        } else {
          this.fetchList();
        }
      }
    },
    'dataTableParams.page': function (newVal, oldVal) {
      this.handleSearchOrFetch(newVal, oldVal);
    },
    'dataTableParams.limit': function (newVal, oldVal) {
      this.dataTableParams.page = 1;
      this.handleSearchOrFetch(newVal, oldVal);
    },
    'dataTableParams.clinicId': function (newVal, oldVal) {
      if (!this.shouldHideClinicSelector) {
        this.handleSearchOrFetch(newVal, oldVal);
      }
    },
  },
  async created() {
    if (!this.shouldHideClinicSelector) {
      const organizationId = localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}OrganizationId`);
      if (organizationId) {
        await this.getOrganizationAllClinicsList(organizationId);
        if (this.clinics.length > 0) {
          this.dataTableParams.clinicId = this.clinics[0].clinicId;
        }
      }
    }
    
    if (!this.shouldUseLazyLoading) {
      this.fetchList();
    } else {
      this.serverResponded = true;
    }
  },
};
</script>
<style scoped>
.mobile-text {
  color: #164d3d;
}
.vs-dropdown-menu {
  z-index: 99999;
}
</style>
